/* eslint-disable @typescript-eslint/no-explicit-any */
import { getUserInfo } from "@/services/userService";
import { findBestMatch } from "string-similarity";

export function formatToDateString(input:string): string | null {
  // Check if input is already in DD/MM/YYYY format or with time
  const dmyRegex = /^(\d{2})\/(\d{2})\/(\d{4})(\s+\d{2}:\d{2}:\d{2})?$/;
  if (dmyRegex.test(input)) {
    const match:any = input.match(dmyRegex);
    return `${match[1]}/${match[2]}/${match[3]}`; // return only DD/MM/YYYY
  }

  // Try parsing ISO or other formats
  const date:any = new Date(input);
  if (!isNaN(date)) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return null; // invalid or unsupported format
}


export function formatDateToLocalInput(dateStr: string | Date): string | null {
  let date: Date;

  if (dateStr instanceof Date) {
    date = dateStr;
  } else if (typeof dateStr === 'string') {
    // Handle "DD/MM/YYYY HH:mm:ss"
    const dmyTimeRegex = /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/;
    const dmyRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;

    let match = dateStr.match(dmyTimeRegex);
    if (match) {
      const [, dd, mm, yyyy, hh, min] = match;
      date = new Date(`${yyyy}-${mm}-${dd}T${hh}:${min}`);
    } else {
      match = dateStr.match(dmyRegex);
      if (match) {
        const [, dd, mm, yyyy] = match;
        date = new Date(`${yyyy}-${mm}-${dd}T00:00`);
      } else {
        // Try native parser (for ISO or valid formats)
        const parsed = new Date(dateStr);
        if (!isNaN(parsed.getTime())) {
          date = parsed;
        } else {
          console.error("Invalid date format:", dateStr);
          return null;
        }
      }
    }
  } else {
    console.error("Unsupported input type");
    return null;
  }

  // Format to datetime-local compatible string
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
}

export function getClosestPoliceStation(policeStation: string): any | null {
  // Get user data from sessionStorage
  const userInfo = getUserInfo();
  if (!userInfo) return null;

  const { policeStations } = userInfo;
  if (!policeStations || policeStations.length === 0) return null;

  // Extract only the Hindi names (you can also use nameEn if needed)
  const stationNames = policeStations.map((s: any) => s.name);

  // Find best match using string similarity
  const bestMatch = findBestMatch(policeStation, stationNames);

  // Return the matched police station object
  const bestStationName = bestMatch.bestMatch.target;
  return policeStations.find((s: any) => s.name === bestStationName);
}

export const capitalize = (s:string) => s[0].toUpperCase() + s.slice(1).toLowerCase();

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file); // This gives Base64 with prefix: data:application/pdf;base64,...
  });
};

